export default __webpack_public_path__ + "static/media/Bosta Fulfillment Upload Template KSA.V4.2.005ee829.xlsx";